import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { useSelector } from "react-redux";

export const Theme = ({ children }) => {
  const { darkMode } = useSelector((state) => state.public);
  const theme = createTheme({
    palette: {
      type: darkMode ? "dark" : "light",
      primary: {
        main: !darkMode ? "#000000" : "#0366d6",
        contrastText: "#fff",
      },
      secondary: {
        main: "#dc004e",
        contrastText: "#fff",
      },
    },

    typography: {
      fontFamily: ['"Poppins"', "Helvetica", "Arial", "sans-serif"].join(","),
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default Theme;
